<template>
  <div :class="classes">
    <div class="icon-box">
      <font-awesome-icon icon="check" v-if="type == 'success'"/>
      <font-awesome-icon icon="times" v-if="type == 'error'"/>
      <font-awesome-icon icon="exclamation-triangle" v-if="type == 'warning'"/>
    </div>
    <div class="content">
      <div class="title" v-if="type == 'success'">Success</div>
      <div class="title" v-if="type == 'error'">Error</div>
      <div class="title" v-if="type == 'warning'">Warning</div>
      <div class="text">{{ text }}</div>
    </div>
    <div class="close-box">
      <font-awesome-icon icon="times-circle" @click="close"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Alert',
  data() {
    return {
      classes: {
        'alert-box': true,
        success: this.type == 'success',
        error: this.type == 'error',
        warning: this.type == 'warning',
        appear: true,
        disappear: false
      }
    }
  },
  props: {
    type: {
      type: String,
    },
    text: {
      type: String,
      default: 'Info text'
    }
  },
  methods: {
    ...mapActions('alerts', ['deleteError', 'deleteWarning', 'deleteSuccess']),
    close() {
      this.classes.appear = false;
      this.classes.disappear = true;
      setTimeout(() => {
        if(this.type == 'error') {
          this.deleteError();
        }
        if(this.type == 'warning') {
          this.deleteWarning();
        }
        if(this.type == 'success') {
          this.deleteSuccess();
        }
      }, 400);
    }
  },
  mounted() {
    setTimeout(this.close, 5000);
  }
}
</script>

<style lang="scss" scoped>
.alert-box { 
  width: 34rem;
  height: 6rem;
  border-radius: 0.5rem;
  position: fixed;
  z-index: 100;
  top: 2rem;
  left: calc(50% - 17rem);
  display: flex;
  flex-direction: row;
  @media (max-width: 600px) {
    width: 90vw;
    height: 6rem;
    top: 1rem;
    left: calc(50% - 45vw);
    position: fixed;
  }

  .icon-box {
    width: 6rem;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.5rem;

    @media (max-width: 600px) {
      width: 5rem;
      height: auto;
    }
  }

  .content {
    flex: auto;
    height: 6rem;
    display: flex;
    flex-direction: column;
    @media (max-width: 600px) {
      width: calc(90vw - 7rem);
      height: auto;
    }

    .title {
      width: 100%;
      height: 3rem;
      display: flex;
      align-items: flex-end;
      font-size: 1.3rem;
      color: white;
      font-weight: bold;
      @media (max-width: 600px) {
        height: unset;
        font-size: 1.1rem;
        flex: auto;
      }
    }

    .text {
      width: 100%;
      height: 3rem;
      display: flex;
      align-items: flex-start;
      padding-top: 0.2rem;
      color: white;
      @media (max-width: 600px) {
        font-size: 0.9rem;
        line-height: 1.1rem;
        height: auto;
        flex: auto;
      }
    }
  }

  .close-box {
    width: 3rem;
    height: 6rem;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    font-size: 1.5rem;
    padding-top: 1rem;
    padding-right: 1rem;
    @media (max-width: 600px) {
      width: 3rem;
      height: auto;
      justify-content: center;
      padding-right: unset;
    }
    
    svg {
      transition: 0.2s;
    }

    svg:hover {
      cursor: pointer;
    }
  }
}

.success {
  background-color: rgb(66, 208, 131);
  .close-box {
    color: rgb(48, 150, 94);
    svg:hover {
      color: rgb(42, 129, 81);
    }
  }
}

.error {
  background-color: rgb(224, 116, 106);
  .close-box {
    color: rgb(173, 90, 82);
    svg:hover {
      color: rgb(155, 79, 72);
    }
  }
}

.warning {
  background-color: #f9c74f;
  .close-box {
    color: #cca344;
    svg:hover {
      color: #c09738;
    }
  }
}

.appear {
  animation: appear 0.3s forwards ease-out;
}

.disappear {
  animation: disappear 0.3s forwards ease-in;
}

//Appear Animation

@keyframes appear {
  0% {
    transform: translateY(-10rem);
  }
  100% {
    transform: translateY(0rem);
  }
}

//Disappear Animation

@keyframes disappear {
  0% {
    transform: translateY(0rem);
  }
  100% {
    transform: translateY(-10rem);
  }
}
</style>